<template>
  <div class="eno-menu">
    <el-menu :default-active="activeIndex" @select="handleSelect" :active-text-color="style.mainTextColor"
             :background-color="style.mainBgColor" class="eno-menu-custom" mode="horizontal" router
             :text-color="style.mainTextColor">
      <el-menu-item key="/" index="/"> 首页</el-menu-item>
      <template v-for="(item, index) in menusList">
        <el-submenu v-if="item.children" class="menu-item" :key="item.name" :index="item.name + index"
                    :popper-class="getPopperClass(item)">
          <template slot="title"> {{ item.name }}</template>
          <template v-for="(menus, menusIndex) in item.children">
            <template v-if="!menus.children">
              <el-menu-item class="menu-item" :index="menus.route" :key="menus.route">
                {{ menus.name }}
              </el-menu-item>
            </template>
            <template v-else>
              <div class="pop-menu-box">
                <div class="pop-menu-group">
                  <div class="pop-menu-title">
                    {{ menus.name }}
                  </div>
                  <div class="pop-menu-group-item">
                    <template v-for="(menu, menuIndex) in menus.children">
                      <el-menu-item class="pop-menu-item menu-item" style="color: #333" :key="menu.route" v-if="true"
                                    :index="menu.route">
                        <span class="underline">{{ menu.name }}</span>
                      </el-menu-item>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </el-submenu>
        <el-menu-item v-else :key="item.route" :index="item.route">
          {{ item.name }}
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import {menu} from "../../../constant/menu.js";
import {style} from "../../../constant/style.js";

export default {
  name: "enoMenu",
  data() {
    return {
      style: style,
      menusList: menu,
    };
  },
  mounted() {
    // 因为样式调整结构要变  ， 也可以直接在menu修改数据结构
    this.menusList = menu?.map(item => {
      if (item?.children?.length) {
        if (!item?.children[0]?.children) {
          return {
            name: item.name,
            // 是否只有一列数据
            isOnlyCol: true,
            children: [item]
          }
        }
      }
      return item
    })
    // window.addEventListener("scroll", this.changeHeadBg);
  },
  computed: {
    // 计算当前激活的菜单项
    activeIndex() {
      return this.getActivePath();
    }
  },
  methods: {
    handleSelect(path, dsada, qeqweq) {
      sessionStorage.setItem('activePath', path)
    },
    getPopperClass(item) {
      // 根据isOnlyCol返回不同的class
      return item.isOnlyCol ? 'only-one-col-popup' : 'multi-col-popup';
    },
    getActivePath() {
      const currentPath = this.$route.path;

      // 遍历菜单找到匹配的路径
      const findMatchingPath = (menus) => {
        for (const menu of menus) {
          if (menu.route) {
            // 提取 route 中的路径部分（去掉查询参数）
            const menuPath = menu.route.split('?')[0];
            if (menuPath === currentPath) {
              return menu.route; // 返回完整的 route（包含查询参数）
            }
          }
          if (menu.children) {
            const childPath = findMatchingPath(menu.children);
            if (childPath) return childPath;
          }
        }
        return null;
      };

      // 先尝试精确匹配
      let matchedPath = findMatchingPath(this.menusList);

      // 如果没有找到，尝试匹配路径（忽略查询参数）
      if (!matchedPath) {
        // 查找路径匹配的菜单项
        const findPathMatch = (menus) => {
          for (const menu of menus) {
            if (menu.route) {
              const menuPath = menu.route.split('?')[0];
              if (menuPath === currentPath) {
                return menu.route;
              }
            }
            if (menu.children) {
              const childPath = findPathMatch(menu.children);
              if (childPath) return childPath;
            }
          }
          return null;
        };
        matchedPath = findPathMatch(this.menusList);
      }
      // 如果还没有匹配，使用当前路径
      return matchedPath || currentPath;
    }
  },
};
</script>

<style lang="less" scoped>
.underline {
}

.underline:hover {
  //   text-decoration: underline;
  border-bottom: 1px solid #fff;
  font-weight: 600;
  cursor: pointer;

}

/deep/ .el-menu-item {
  height: 65px !important;
  background-color: @mainBgColor !important;
}

/deep/ .el-submenu__title {
  height: 65px !important;
  padding: 0 !important;
}

/deep/ .el-menu {
  border-bottom: 0px !important;
}

/deep/ .el-menu-item:hover {
  background-color: @mainBgColor !important;
  font-weight: 600;
}

/deep/ .el-submenu__title:hover {
  background-color: @mainBgColor !important;
  font-weight: 600;
}

/deep/ .is-active {
  border-bottom-color: @mainColor !important;
}

/deep/ .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom-color: @mainColor !important;
}

.eno-menu-custom {
  /deep/ li {
    margin-right: 24px;
  }
}

.pop-menu-box {
  color: @mainTextColor;
  background-color: @black;
  padding-left: 20px;
  text-align: left;
  display: flex;
  float: left;
  padding: 0 60px 20px 40px;

  .pop-menu-group {
    background-color: @black;

    .pop-menu-group-item {
      padding-top: 16px;
      display: flex;
      flex-direction: column;
    }

    .pop-menu-title {
      border-bottom: 1px solid @mainGrayColor !important;
      line-height: 35px !important;
      color: @mainGrayColor;
      padding-bottom: 12px;
    }

    .pop-menu-item {
      font-size: @mainFontSize !important;
      color: @mainTextColor !important;
      background-color: @black !important;
      height: 30px !important;
      line-height: 30px !important;
      min-width: 100px !important;
      padding: 0 !important;
    }
  }
}
</style>

<style lang="less">
.only-one-col-popup {
  .el-menu--popup {
    max-width: 251px;
    display: grid;
    background-color: @black !important;
  }
}

// 多列弹出菜单
.multi-col-popup {
  .el-menu--popup {
    max-width: 90vw;
    display: grid;
    grid-template-columns: repeat(auto-fill, 250px);
    background-color: @black !important;
  }

  .el-menu--popup::before {
    display: none;
  }
}

.el-submenu__icon-arrow {
  display: none !important;
}
</style>
